import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewPlatformId } = appStoreLenses

export default viewPlatformId
